import { FC } from 'react'
import { RestaurantMainCard } from '@widgets/Restaurant/RestaurantMainCards/ui/RestaurantMainCard'
import { TypeMappingRestOutput } from '@shared/api/middleware/mappingAPI/restaurant/type'
import { SectionMainCarousel } from '@shared/ui/Layout/SectionMainCarousel'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { log } from '@shared/lib/helpers/debugLog'
import { PickAnalytic } from '@shared/api/analytics/types/types'
import { RestaurantMainCardsSkeleton } from '@widgets/Restaurant/RestaurantMainCards/index'

interface Props {
  list: TypeMappingRestOutput[]
  analytic?: PickAnalytic<null, 'section_name' | 'section_index' | 'section_type'>
  skeleton?: boolean
}

const RestaurantMainCards: FC<Props> = ({ list: listRest, analytic, skeleton = false }) => {
  log('RestaurantMainCards', { skeleton, listCount: listRest?.length ?? 0 })
  if (!skeleton && !listRest?.length) return

  return (
    <BlockBoundary>
      {skeleton ? (
        <RestaurantMainCardsSkeleton />
      ) : (
        <SectionMainCarousel>
          {listRest.map((coverRestItem, index) => (
            <RestaurantMainCard
              data={coverRestItem}
              analytic={{ section_index: index, ...analytic }}
              key={coverRestItem.id}
            />
          ))}
        </SectionMainCarousel>
      )}
    </BlockBoundary>
  )
}

export default RestaurantMainCards
